import { defineStore } from "pinia";
import { http } from "./https";
import { LOCAL } from "@/constants";

export const useSearchStore = defineStore("search", {
  state: () => ({
    games: [],
    autoCompleteList: [],
    query: "",
  }),
  actions: {
    async fetchSearchData(searchQuery) {
      try {
        this.query = searchQuery.trim();
        const selectedLocale = localStorage.getItem(LOCAL) || "en";

        const response = await http.get('/search', {
          params: {
            title: searchQuery.trim(),
            lang: selectedLocale,
          },
        });
    
        this.games = response.data.result;
        this.autoCompleteList = [];
        return response;
      } catch (error) {
        console.error('Error fetching search data:', error);
        throw error;
      }
    },
    async autocompleteSearch(searchQuery) {
      try {
        this.query = searchQuery.trim();
        const selectedLocale =
          localStorage.getItem(LOCAL) || "en";
    
        // Clear the autocomplete list before fetching new data
        this.autoCompleteList = [];
    
        // Make the HTTP request using POST method
        const response = await http.post('/autocomplete-search', {
          title: searchQuery.trim(),
          lang: selectedLocale
        });
    
        // Update the autocomplete list and return the response data
        this.autoCompleteList = response.data.result;
        return response.data;
      } catch (error) {
        console.error('Error during autocomplete search:', error);
        throw error; // Optionally re-throw the error if further handling is needed
      }
    }
  },
});
